<script setup>
import { defineProps } from 'vue'
import Currency from '../../components/Currency.vue'
import UserAvatar from '@/components/UserAvatar.vue';

defineProps(['bestWins'])
</script>

<template>
  <!-- Statistiche Rapide -->
  <v-row class="align-stretch mb-6">
    <v-col v-if="bestWins.best_month_win" cols="12" sm="6">
      <v-card class="pa-4" color="success" variant="tonal">
        <div class="d-flex align-center justify-space-between">
          <div>
            <p class="text-subtitle-2 text-medium-emphasis mb-1">{{ $t('dashboard.winOfTheMonth') }}</p>
            <h2 class="text-h4 font-weight-bold">
              <Currency :amount="(bestWins.best_month_win.payout - bestWins.best_month_win.amount)" />
            </h2>
            <span class="text-truncate">{{ bestWins.best_month_win.user.name }}</span>
          </div>
          <UserAvatar color="success" :avatar="bestWins.best_month_win.user.name.charAt(0).toUpperCase()" />
        </div>
      </v-card>
    </v-col>
    <v-col v-if="bestWins.best_week_win" cols="12" sm="6">
      <v-card class="pa-4" color="primary" variant="tonal">
        <div class="d-flex align-center justify-space-between">
          <div>
            <p class="text-subtitle-2 text-medium-emphasis mb-1">{{ $t('dashboard.winOfTheWeek') }}</p>
            <h2 class="text-h4 font-weight-bold">
              <Currency :amount="(bestWins.best_week_win.payout - bestWins.best_week_win.amount)" />
            </h2>
            <span class="text-truncate">{{ bestWins.best_week_win.user.name }}</span>
          </div>
          <UserAvatar color="primary" :avatar="bestWins.best_week_win.user.name.charAt(0).toUpperCase()" />
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
.v-card {
  transition: transform 0.2s ease-in-out;
}

.v-card:hover {
  transform: translateY(-2px);
}
</style>